import React, { useState, useEffect } from "react"

import PageSection from "../../../PageSection/PageSection.component"
import { PageComponentPropsI } from "../../../../components/layout-components/_/PageComponentTypes"
import SliderNav, { arrowColorType } from "../../../../components/layout-components/_/sliders/SliderNav/SliderNav.component"
import { ourPreviousWorkCss } from "./css/ourPreviousWork.css.func"
import { FlattenSimpleInterpolation } from "styled-components"

import { shuffleArray } from "../../../../utils/shuffleArray";

type sliderTexts = Array<{
  title: string,
  text: string,
  stars: number
}>;

interface OurPreviousWorkPropsI extends PageComponentPropsI {
  testimonials?: sliderTexts;
  testimonialsBackgroundColor?: string;
  arrowColorType?: string;
  pageNumberColor?: string;
  activePageUnderlineColor?: string;
}

const defaultSliderTexts = [
  {
    title: "Lorem ipsum dolor sit amet",
    text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. <br /><br />Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.",
    stars: 3
  },
  {
    title: "Aenean commodo ligula eget dolor",
    text: "Drumstick tenderloin pork loin, shankle pork belly brisket prosciutto filet mignon salami short loin ham shoulder chuck pork chop. Tail short loin turkey alcatra pork filet mignon biltong drumstick ribeye jowl. Pork loin short ribs turducken capicola pig rump leberkas t-bone shank beef ribs, turkey fatback. Chicken hamburger shankle, meatloaf prosciutto ground round chuck cow. Flank chislic bresaola leberkas.",
    stars: 5
  },
  {
    title: "Tail short loin turkey alcatra pork filet mignon",
    text: "Pork loin short ribs turducken capicola pig rump leberkas t-bone shank beef ribs, turkey fatback. Chicken hamburger shankle, meatloaf prosciutto ground round chuck cow. Flank chislic bresaola leberkas. Drumstick tenderloin pork loin, shankle pork belly brisket prosciutto filet mignon salami short loin ham shoulder chuck pork chop. Tail short loin turkey alcatra pork filet mignon biltong drumstick ribeye jowl. ",
    stars: 4
  }
];

const getRatingStars = (rating: number): string|undefined => {

  switch (rating) {

    case 1: {
      return "★☆☆☆☆";
    } break;

    case 2: {
      return "★★☆☆☆";
    } break;

    case 3: {
      return "★★★☆☆";
    } break;

    case 4: {
      return "★★★★☆";
    } break;

    case 5: {
      return "★★★★★";
    } break;
  
  }

}


const OurPreviousWork: React.FC<OurPreviousWorkPropsI> = (props: OurPreviousWorkPropsI) => {

  const [sliderIndex, setSliderIndex] = useState(0);
  const [sliderTexts, setSliderTexts] = useState(props.testimonials ?? defaultSliderTexts);

  // let sliderTexts: sliderTexts = props.testimonials ?? defaultSliderTexts;

  if (sliderTexts.length > 6) {
    // sliderTexts = shuffleArray(sliderTexts).slice(0, 6);
    setSliderTexts(shuffleArray(sliderTexts).slice(0, 6));
  }

  return (

    <PageSection extendStyles={ourPreviousWorkCss({testimonialsBackgroundColor: props.testimonialsBackgroundColor}) as unknown as FlattenSimpleInterpolation}>

      <div className="text-center">

        <h2 className="section-title">Our previous work</h2>

        <p className="text">We've been at this game for a good part of a decade now, so we've both ghostritten and published lots of unique material for our clients. You can look at some of our more popular pieces below.</p>

        </div>

        <div className="testimonials">

        <div className="testimonials--inner-container">
          <div className="testimonials__testimonial">
            
            <div className="testimonials__testimonial__source-logo"></div>

            <div className="testimonials__testimonial__content">

              <p 
                className="testimonials__testimonial__content__title"
                dangerouslySetInnerHTML={{
                  __html: sliderTexts[sliderIndex].title
                }}
              />

              <p 
                className="testimonials__testimonial__content__text"
                dangerouslySetInnerHTML={{
                  __html: sliderTexts[sliderIndex].text
                }}
              />

              <hr className="testimonials__testimonial__content__divider" />

              <div className="testimonials__testimonial__content__rating">{getRatingStars(sliderTexts[sliderIndex].stars)}</div>

            </div>

          </div>
        </div>

        <div className="testimonials--bottom-nav-container">

          <div className="testimonials__nav">

            <SliderNav
              className="slider-nav"
              arrowColorType={props.arrowColorType ?? arrowColorType.YELLOW}
              pageNumberColor={props.pageNumberColor ?? "black"}
              activePageUnderlineColor={props.activePageUnderlineColor ?? undefined}
              totalPages={sliderTexts.length}
              currentPage={sliderIndex + 1}
              onPageClick={page => setSliderIndex(page - 1)}
            />

          </div>

        </div>

      </div>

      <div className="testimonials-notice">

        <div className="testimonials-notice__texts">
          <span className="testimonials-notice__texts__notice-prefix-text">Just a side note</span>
          <p className="testimonials-notice__texts__text">: All reviews of our work provided above are taken from our Upwork profile page. We're only displaying several of them (6 to be precise) at a time to avoid clutter. If you need more examples or want to verify that we're not just cherry-picking a few of the best ones, you can visit us at Upwork and check for yourself – <a target="_blank" href="https://www.upwork.com/o/companies/~01258ca8260faa5fe5/">PodroomCreative Upwork profile page.</a>
          </p>
        </div>

      </div>

    </PageSection>

  )

}

export default OurPreviousWork;